module.exports = __webpack_public_path__ + "img/Number=53.f790cd02.png";